import React, {Suspense, lazy, useEffect} from 'react';
import {UpdateAuth} from "./components/user/auth";
import {Route, Routes} from "react-router-dom";
import PrivateRouter from "./components/PrivateRouter";
import AuthRouter from "./components/AuthRouter";
import Layout from "./components/Layout/Layout";
import "./App.scss"
import {HostInit} from "./components/initVars/HostInit";
import Loading from "./components/Loading/Loading";
import {AuthStatus} from "./models/StoreModels";
import {useAppDispatch, useAppSelector} from "./store/hooks/redux";

const LessonPage = lazy(() => import("./pages/lessonPage/LessonPage"));
const LessonItemPage = lazy(() => import("./pages/lessonPage/LessonItemPage"));
const LessonAddPage = lazy(() => import("./pages/lessonPage/LessonAddPage"));
const FimboPage = lazy(() => import("./pages/fimboPage/FimboPage"));
const FimboItemPage = lazy(() => import("./pages/fimboPage/FimboItemPage"));
const FimboAddPage = lazy(() => import("./pages/fimboPage/FimboAddPage"));
const AudioPage = lazy(() => import("./pages/audioPage/AudioPage"));
const AudioItemPage = lazy(() => import("./pages/audioPage/AudioItemPage"));
const AudioAddPage = lazy(() => import("./pages/audioPage/AudioAddPage"));
const LessonTypePage = lazy(() => import("./pages/lessonTypePage/LessonTypePage"));
const LessonTypeItemPage = lazy(() => import("./pages/lessonTypePage/LessonTypeItemPage"));
const LessonTypeAddPage = lazy(() => import("./pages/lessonTypePage/LessonTypeAddPage"));
const VariablePage = lazy(() => import("./pages/variablePage/VariablePage"));
const VariableItemPage = lazy(() => import("./pages/variablePage/VariableItemPage"));
const VariableAddPage = lazy(() => import("./pages/variablePage/VariableAddPage"));
const GenrePage = lazy(() => import("./pages/genrePage/GenrePage"));
const GenreItemPage = lazy(() => import("./pages/genrePage/GenreItemPage"));
const GenreAddPage = lazy(() => import("./pages/genrePage/GenreAddPage"));
const SoulPage = lazy(() => import("./pages/soulOptionPage/SoulPage"));
const SoulItemPage = lazy(() => import("./pages/soulOptionPage/SoulItemPage"));
const SoulAddPage = lazy(() => import("./pages/soulOptionPage/SoulAddPage"));
const AnalyticPage = lazy(() => import("./pages/analyticPage/AnalyticPage"));
const RecoverPage = lazy(() => import("./pages/recoverPage/RecoverPage"));

function App() {
    const dispatch = useAppDispatch()
    const {authStatus} = useAppSelector(state => state.userReducer)

    useEffect(() => {
        UpdateAuth(dispatch).then()
    }, [dispatch])

    useEffect(() => {
        if (authStatus === AuthStatus.Authorized) {
            HostInit(dispatch).then()
        }
    }, [dispatch, authStatus])

    return (
        <Suspense fallback={<Loading/>}>
            <Routes>
                <Route path="/" index element={<AuthRouter/>}/>
                <Route element={<PrivateRouter/>}>
                    <Route element={<Layout/>}>
                        <Route path="/recover" element={<RecoverPage/>}/>

                        <Route path="/lesson" element={<LessonPage/>}/>
                        <Route path="/lesson/:id" element={<LessonItemPage/>}/>
                        <Route path="/lesson/add" element={<LessonAddPage/>}/>

                        <Route path="/fimbo" element={<FimboPage/>}/>
                        <Route path="/fimbo/:id" element={<FimboItemPage/>}/>
                        <Route path="/fimbo/add" element={<FimboAddPage/>}/>

                        <Route path="/audio" element={<AudioPage/>}/>
                        <Route path="/audio/:id" element={<AudioItemPage/>}/>
                        <Route path="/audio/add" element={<AudioAddPage/>}/>

                        <Route path="/lesson-type" element={<LessonTypePage/>}/>
                        <Route path="/lesson-type/:id" element={<LessonTypeItemPage/>}/>
                        <Route path="/lesson-type/add" element={<LessonTypeAddPage/>}/>

                        <Route path="/variable" element={<VariablePage/>}/>
                        <Route path="/variable/:id" element={<VariableItemPage/>}/>
                        <Route path="/variable/add" element={<VariableAddPage/>}/>

                        <Route path="/genre" element={<GenrePage/>}/>
                        <Route path="/genre/:id" element={<GenreItemPage/>}/>
                        <Route path="/genre/add" element={<GenreAddPage/>}/>

                        <Route path="/soul" element={<SoulPage/>}/>
                        <Route path="/soul/:id" element={<SoulItemPage/>}/>
                        <Route path="/soul/add" element={<SoulAddPage/>}/>

                        <Route path="/analytics" element={<AnalyticPage/>}/>
                    </Route>
                </Route>

            </Routes>
        </Suspense>
    );
}

export default App;
